export const loadFingerprint = () =>
  new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "/scripts/irs_fingerprint2_2_1_5.js";
    script.async = true;

    script.onload = () => {
      setTimeout(() => {
        const Fingerprint = window.Fingerprint2;

        if (!Fingerprint || typeof Fingerprint.get !== "function") {
          return reject(new Error("Fingerprint.get is not available"));
        }

        Fingerprint.get(async (components) => {
          try {
            const values = components.map(c => c.value).join("");
            const deviceId = await Fingerprint.sha256(values);

            resolve(deviceId.toUpperCase());
          } catch (err) {
            reject(new Error("Error generating SHA-256 hash: " + err));
          }
        });
      }, 50);
    };

    script.onerror = err => {
      console.error("Fingerprint script load error:", err);
      reject(err);
    };

    document.body.appendChild(script);
  });
